import requests from 'api/index';

const prefixURL = '/board';
const boardApi = {
  // 처음 게시판메뉴 생성을 위한 api
  listCompByLvl: payload => requests.get(`${prefixURL}/rest/v1/admin/common/listCompByLvl`),
  crateBoard: payload => requests.post(`${prefixURL}/rest/v1/admin/boards/create`, payload),
  getTopMenu: payload => requests.get(`${prefixURL}/rest/v1/admin/topmenu/list?${payload}`),
  deleteBoard: payload => requests.post(`${prefixURL}/rest/v1/admin/boards/delete?brdNo=${payload.brdNo}`, {}),
};
export default boardApi;
